import { useState } from 'react';

export function useProviderMenuAction() {
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  return {
    isUpdateModalOpen,
    isDeleteModalOpen,
    handleOpenUpdateModal: () => setIsUpdateModalOpen(true),
    handleCloseUpdateModal: () => setIsUpdateModalOpen(false),
    handleOpenDeleteModal: () => setIsDeleteModalOpen(true),
    handleCloseDeleteModal: () => setIsDeleteModalOpen(false),
  };
}
